import React from "react";
import QuoteHero from "./QuoteHero";
import QuoteForm from "./QuoteForm";
import Footer from "../../Footer";

const QuotePage = () => {
  return (
    <>
      <QuoteHero />
      <QuoteForm />
      <Footer showGetStarted={false} />
    </>
  );
};

export default QuotePage;
